import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  ADMIN_DISTRIBUTION_OPTIONS,
  DISTRIBUTION_TYPE_EVERYONE,
  DISTRIBUTION_TYPE_ORGANIZATION,
  VIEWER_DISTRIBUTION_OPTIONS,
} from '../../constants/SmartInsightConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import RowField from '../../report-designer/components/RowField';
import { getHasSupervisorRight } from '../../selectors/SmartInsightSelectors';

const useStyles = makeStyles({
  select: {
    margin: 0,
    flex: 1,
    maxWidth: 300,
  },
});

const DistributionFor = ({ distributionForValueStore, onChangeDistributionValue, isAdmin }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [value, setValue] = useState(distributionForValueStore);

  const hasSupervisorRight = useSelector(getHasSupervisorRight);

  useEffect(() => {
    setValue(distributionForValueStore);
  }, [distributionForValueStore]);

  const options = isAdmin ? ADMIN_DISTRIBUTION_OPTIONS : VIEWER_DISTRIBUTION_OPTIONS;
  const currentValue =
    value === DISTRIBUTION_TYPE_ORGANIZATION ? DISTRIBUTION_TYPE_EVERYONE : value;
  const viewOnlyValue = options.find(({ value }) => value === currentValue)?.label;

  return (
    <RowField
      rowLabel="Distribution List For"
      isViewOnly={!hasSupervisorRight}
      viewOnlyValue={viewOnlyValue}
    >
      <Select
        className={classes.select}
        value={currentValue}
        onChange={onChangeDistributionValue}
        canDeselect={false}
      >
        {options.map((option, index) => (
          <MenuItem key={option.value + index} value={option.value}>
            {translateString(option.label)}
          </MenuItem>
        ))}
      </Select>
    </RowField>
  );
};

export default DistributionFor;
